import styled from 'styled-components/macro';

const FileUpload = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color: #1a1616;

  .uploadDropZone {
    align-self: center;
    display: flex;
    flex-direction: row;
    padding: 0;
    height: 270px;
    margin: 0;
  }

  .uploadType {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
    font-size: 14px;
    line-height: 1.2;
    opacity: 0.4;
    color: #fff;
    transition: opacity 0.25s ease-in-out;

    & > div {
      margin-top: 15px;
    }

    &:hover {
      opacity: 1;
    }
  }
`;

export default FileUpload;
